<div
  class="expandable-panel"
  [class.expanded-h-50]="isExpanded && expandedHeight === '50'"
  [class.expanded-h-30]="isExpanded && expandedHeight === '30'"
  [class.collapsed]="!isExpanded"
>
  <div
    *ngIf="!isExpanded"
    class="collapsed-content "
    (click)="togglePanel()"
    style="background-color: #fff9f9; color: rgb(0, 0, 0); display: flex;margin-left: 10px;"
  >
    <!-- Luggage Item -->
    <div style="display: flex; align-items: center; gap: 3px">
      <i class="material-icons">luggage </i>
      <span class="site-text text-lg font-bold">
        <!-- luggage -->
        x {{this.luggageControl.value }}
      </span>
    </div>

    <!-- Passengers Item -->
    <div style="display: flex; align-items: center; gap: 3px">
      <i class="material-icons">person</i>
      <span class="site-text text-lg font-bold">
        <!-- passengers -->
        x {{  this.qtyControl.value  }}
      </span>
    </div>
    <div style="display: flex; align-items: center; gap: 3px" [ngClass]="{ 'type-animation': taxiType !=1 && taxiType != 2  }" >
      <i class="material-icons"  [ngClass]="{ 'taxi-icon': taxiType !=1 && taxiType != 2  }">
        <img src="icons/taxi-5-svgrepo-com.svg" style="width: 30px;height: 30px;" alt="Wetaxi logo" width="18" height="18"/>
      </i>
      <span 
        class="site-text text-lg font-bold " [ngClass]="{ 'taxi-text': taxiType !=1 && taxiType != 2  }"
        style="font-size: 10px;">
        {{ (taxiType == 1 ? 'BOOKING.DRIVER_DETAILS.TAXI_TYPE.BIG' 
            : taxiType == 2 ? 'BOOKING.DRIVER_DETAILS.TAXI_TYPE.SMALL' 
            : 'Type?') | translate }}
      </span>
    </div>
    <div style="cursor: pointer">
      <i class="material-icons"> keyboard_control_keys </i>
    </div>

    <!-- <button class="btn btn-primary" (click)="togglePanel()">&gt;</button> -->
  </div>

  <div *ngIf="isExpanded" class="expanded-content d-flex flex-column bg-transparent"  style="background: none;">
    <div
      class="toggle-panel-button"
      (click)="togglePanel()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="15" viewBox="0 0 28 15" fill="none">
  <path d="M0.62148 0.619165C-0.20716 1.43463 -0.20716 2.75687 0.62148 3.57231L11.0019 13.7782C12.6595 15.4078 15.3453 15.4072 17.002 13.7769L27.3784 3.5648C28.2072 2.74936 28.2072 1.42711 27.3784 0.611628C26.5498 -0.203876 25.2063 -0.203876 24.3777 0.611628L15.4966 9.35203C14.668 10.1677 13.3244 10.1675 12.4959 9.35203L3.6222 0.619165C2.79358 -0.196338 1.4501 -0.196338 0.62148 0.619165Z" fill="#0F0F0F"/>
</svg>
    </div>

    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
